import { createPageDataFeature } from '../../page-data/create-page-data-feature';
import { Profile } from 'src/app/shared/entities/profile';
import { createDeleteItemFeature } from '../../delete-item/delete-item-feature';

export const {
  feature: profileDataFeature,
  selectors: ProfileDataSelectors,
  actions: ProfileDataActions,
  pipes: ProfileDataPipes,
  createEffects: createProfileDataEffects,
} = createPageDataFeature<'Profile Data', void, Profile[]>('Profile Data');

export const {
  feature: profileDeleteFeature,
  actions: ProfileDeleteActions,
  createEffects: createProfileDeleteEffects,
} = createDeleteItemFeature<'Profile Delete', Profile>('Profile Delete');

export const ProfileDeleteSelectors = {
  profileBeingDeleted: profileDeleteFeature.selectItemBeingDeleted,
  isDeleting: profileDeleteFeature.selectDeleting,
};
